import { render, staticRenderFns } from "./KeystoneMarketResearchAdminPage.vue?vue&type=template&id=7badee30&"
import script from "./KeystoneMarketResearchAdminPage.vue?vue&type=script&lang=js&"
export * from "./KeystoneMarketResearchAdminPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports